// extracted by mini-css-extract-plugin
export default {"bottomCardInfo":"_24Nth","vasTagsContainer":"_3wDsi","monetizationDark1":"_28Luc","moreInfo":"_2m6UQ","infoIcn":"_2_uoG"};